import { PrizeType } from 'entities/prize/model';
import { PrizeFormType } from 'entities/prize/model/prize';

export const useUpdatePrizeCardDefaultValues = (prize: PrizeType): PrizeFormType => ({
  prize_type_id: prize.prize_type_id,
  min_start_date: prize.min_start_date,
  max_end_date: prize.max_end_date,
  name_ru: prize.name.ru,
  name_kz: prize.name.kz,
  name_uz: prize.name.uz,
  name_kg: prize.name.kg,
  description_ru: prize.description.ru,
  description_kz: prize.description.kz,
  description_uz: prize.description.uz,
  description_kg: prize.description.kg,
  category: prize.category,
  image: prize.image,
  icon: prize.icon,
  prize_file: null,
  is_generated: false,
});
